import { render, staticRenderFns } from "./AxxessFtthWizard.vue?vue&type=template&id=4e77f170&"
import script from "./AxxessFtthWizard.vue?vue&type=script&lang=js&"
export * from "./AxxessFtthWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports